module.exports = __webpack_public_path__ + "img/absence.d4ac5109.png";